import { z } from "zod";

export const RefineTone = {
	PROFESSIONAL: "professional",
	ENTHUSIASTIC: "enthusiastic",
	CASUAL: "casual",
	INSPIRING: "inspiring",
} as const;
export type RefineTone = (typeof RefineTone)[keyof typeof RefineTone];

export const refinePostSchema = z.object({
	content: z.string().min(1, { message: "Content is required" }),
	tone: z.enum(["professional", "enthusiastic", "casual", "inspiring"]),
});

export type RefinePostPayload = z.infer<typeof refinePostSchema>;
